const getProductJSON = async (handle) => {
    let data = JSON.parse(sessionStorage.getItem('productJSONStore'));

    if (data && data[handle]) {
        return data[handle];
    } else {
        await getStorefrontProduct(handle).then(product => {
            saveProductJSON(product);
            return product;
        });
    }
}

const saveProductJSON = (product) => {
    let data = JSON.parse(sessionStorage.getItem('productJSONStore'));

    if (data == null) {
        data = {};
    }

    if (product) {
        data[product.handle] = product;
    }

    sessionStorage.setItem('productJSONStore', JSON.stringify(data));
}

const removeProductJSON = (product) => {
    let data = JSON.parse(sessionStorage.getItem('productJSONStore'));

    if (data == null) {
        data = {};
    }

    if (product) {
        delete data[product.handle];
    }

    sessionStorage.setItem('productJSONStore', JSON.stringify(data));
}

const getStorefrontProduct = (handle) => {
    return fetch(`${Shopify.routes.root}products/${handle}.js`).then((response)=>{ return response.json() });
}

const enrichWidgetProducts = (widget) => {
    const products = widget.data.products;

    for (var i = 0; i < products.length; i++) {
        updateProductJSON(products[i], () => {
            widget.initProducts(widget.data.products);
        });
    }
}

const enrichCartItems = () => {
    const items = Rebuy.Cart.items();
    for (var i = 0; i < items.length; i++) {
        const item = items[i];
        const product = items[i].product;

        updateProductJSON(product, () => {
            const productClone = Object.assign({}, product);

            delete productClone.subscription;
            delete productClone.subscription_discount_amount;
            delete productClone.subscription_discount_type;
            delete productClone.subscription_frequencies;
            delete productClone.subscription_frequency;
            delete productClone.subscription_interval;
            delete productClone.subscription_id;
            delete productClone.is_subscription_only;
            delete productClone.has_subscription;

            Rebuy.Cart.addEnrichedProduct(productClone);

            Rebuy.Cart.initProduct(product, { 
                item: item,
                clone: true 
            });
        });
    }
}

const updateProductJSON = async (product, callback=function(){}) => {
    await getProductJSON(product.handle).then(json => {

        if (typeof json.requires_selling_plan != 'undefined') {
            product.is_subscription_only = json.requires_selling_plan;
        }

        if (typeof json.selling_plan_groups != 'undefined') {

            let selling_plan_group = json.selling_plan_groups.find(x => x.options[0].name.includes(product.selected_variant_id));
            if (selling_plan_group) {
              extendProductWithSellingPlan(product, selling_plan_group);
            } else {
              extendProductWithSellingPlan(product, json.selling_plan_groups[0]);
            }
            
        }

        callback(product);
    });
}

const extendProductWithSellingPlan = (product, selling_plan_groups) => {

    if (product && selling_plan_groups) {

        // Set discount
        selling_plan_groups.discount_amount = 0;
        selling_plan_groups.discount_type = 'none';

        // Update selling plans
        for (let i = 0; i < selling_plan_groups.selling_plans.length; i++) {
            const selling_plan = selling_plan_groups.selling_plans[i];

            // Surface discount amount and type to groups
            if (selling_plan_groups.discount_amount == 0 && selling_plan_groups.discount_type == 'none' && selling_plan.price_adjustments.length > 0) {
                let price_adjustment = selling_plan.price_adjustments[0];
                let valueType = (price_adjustment.value_type === "percentage") ? "percentage" : "fixed";
                let value = price_adjustment.value;

                if (valueType === "fixed") {
                    value = (value / 100).toFixed(2);
                }

                selling_plan_groups.discount_amount = value;
                selling_plan_groups.discount_type = valueType;
            }

            // Surface order interval to selling plan
            let interval = getOrderIntervalForOptions(selling_plan.options[0]);
            selling_plan.order_interval_frequency = interval.frequency;
            selling_plan.order_interval_unit_type = interval.unit;
        }

        // Add groups to product
        product.selling_plan_groups = [selling_plan_groups];
    }
}

const getOrderIntervalForOptions = (option) => {
    const intervalUnits = ['day', 'week', 'month', 'year'];
    const response = {
        frequency: 1,
        unit: 'day'
    };

    let frequency = option.value.toLowerCase().match(/\d+/g);

    if (frequency != null) {
        response.frequency = frequency[0];
    }

    for (let i = 0; i < intervalUnits.length; i++) {
        const unit = intervalUnits[i];
        let regex = new RegExp(unit, 'g');

        if (option.value.toLowerCase().match(regex)) {
            response.unit = unit;
            break;
        }
    }

    return response;
}

const enableSellingPlans = () => {
    const Rebuy = window.Rebuy;
    const Shop = window.Rebuy.shop;

    if (Shop) {
        if (typeof Shop.integrations == 'undefined') { Shop.integrations = {} };
        Shop.integrations.recharge = true;
        Shop.selling_plans_enabled = true;
    }
}

document.addEventListener('rebuy:cart.enriched', (event) => {
    setTimeout(enrichCartItems, 0);
});

document.addEventListener('rebuy.productsChange', (event) => {
    event.detail.widget.data.config.product_type = 'both';
    enrichWidgetProducts(event.detail.widget);
});

document.addEventListener('rebuy.loaded', () => {
    enableSellingPlans();
});

// may or may not be necessary, have needed to do this on a few stores
document.addEventListener("rebuy:cart.change", () => {
    // re-enrich cart
    setTimeout(() => {
        Rebuy.Cart.enrichCart();
    }, 300);
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.href.includes("/products/")) {
      let handle = window.location.href.split("/products/")[1];
      if (handle.includes("?")) {
          handle = handle.split("?")[0];
      }
      getProductJSON(handle);
  }
})